module.exports = __webpack_public_path__ + "static/media/purple.b272fd86.ogg";